<template>
    <typo :class="cspClasses" name="ci-body">
        <typo v-if="titleTag" name="body-16-normal"> {{ getOptionLabel(titleTag) }} </typo>
        <v-card class="rates-wrapper" elevation="3">
            <div class="rates-container">
                <div class="rates-container-inner rates-container-background">
                    <div class="rate-title">
                        <typo name="body-16-normal"> Taux </typo>
                    </div>
                    <div v-if="!hasRates">
                        <span> Non définis </span>
                    </div>
                    <ul v-if="hasRates">
                        <li v-for="(rate, index) in annotation.rates" :key="index">
                            <span v-if="rate.insuredEntity"
                                >{{ upperFirstLetter(getOptionLabel(rate.insuredEntity)) }} :
                            </span>
                            <span v-if="checkIsNumber(rate.value)">
                                {{ parseNumericValue(rate.value) }}
                                {{ getOptionLabel(rate.unit) }}
                            </span>
                            <span v-if="rate.salaryBase">
                                {{ getOptionLabel(rate.salaryBase) }}
                            </span>
                            {{ rate.min ? "minimum" : "" }}
                        </li>
                    </ul>
                    <div
                        class="rates-text"
                        v-if="annotation.ratesText"
                        v-html="annotation.ratesText"
                    />
                </div>
                <div class="rates-container-inner">
                    <div class="rate-title">
                        <typo name="body-16-normal"> Répartition </typo>
                    </div>

                    <div v-if="!hasDistributions">
                        <span> Non définis</span>
                    </div>
                    <div v-if="hasDistributions">
                        <div>
                            <div
                                v-for="(distribution, index) in annotation.rateDistributions"
                                :key="index"
                            >
                                <div v-if="distribution.salaryBase">
                                    {{ getOptionLabel(distribution.salaryBase) }}
                                </div>
                                <ul>
                                    <li
                                        v-if="
                                            distribution.employer &&
                                                checkIsNumber(distribution.employer.value)
                                        "
                                    >
                                        A la charge de l'employeur :
                                        {{ parseNumericValue(distribution.employer.value) }}
                                        {{ getOptionLabel(distribution.employer.unit) }}
                                        {{ getMinMaxLabel(distribution.employer) }}
                                    </li>
                                    <li
                                        v-if="
                                            distribution.employee &&
                                                checkIsNumber(distribution.employee.value)
                                        "
                                    >
                                        A la charge du salarié :
                                        {{ parseNumericValue(distribution.employee.value) }}
                                        {{ getOptionLabel(distribution.employee.unit) }}
                                        {{ getMinMaxLabel(distribution.employee) }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div
                        class="rates-text"
                        v-if="annotation.rateDistributionsText"
                        v-html="annotation.rateDistributionsText"
                    />
                </div>
            </div>
            <div v-if="filteredTags.length > 0" class="tags-container">
                <span v-for="tag in filteredTags" :key="tag._uid" class="tags-badge">
                    {{ getOptionLabel(tag) }}
                </span>
            </div>
        </v-card>
    </typo>
</template>

<script>
import Vue from "vue";
import { get, intersection, upperFirst, isNull } from "lodash";

export default Vue.extend({
    props: ["annotation", "annotationOptions"],
    data() {
        return {
            annotationsDico: this.$privateDico.convention.annotations,
            ratesTagsTitles: [
                "taux-cotisation-regime-general",
                "taux-cotisation-regime-alsace-moselle",
            ],
        };
    },
    computed: {
        cspClasses() {
            return this.annotation.cspCodes
                .map(code => `csp-${code}`)
                .join(" ")
                .toLowerCase();
        },
        hasRates() {
            return this.annotation.rates && this.annotation.rates.length > 0;
        },
        hasDistributions() {
            return (
                this.annotation.rateDistributions && this.annotation.rateDistributions.length > 0
            );
        },
        titleTag() {
            return intersection(this.annotation.tags, this.ratesTagsTitles);
        },
        filteredTags() {
            return this.annotation.tags.filter(
                tag => [...this.ratesTagsTitles, "compact-info"].indexOf(tag) < 0
            );
        },
    },
    methods: {
        getOptionLabel(code) {
            return get(this.annotationOptions, `${code}.label`, "");
        },
        getMinMaxLabel(distribution) {
            if (!distribution) {
                return "";
            }
            if (distribution.min) {
                return "minimum";
            }
            if (distribution.max) {
                return "maximum";
            }
            return "";
        },
        parseNumericValue(rateValue) {
            return Number.isInteger(rateValue)
                ? rateValue
                : rateValue.toLocaleString("fr-FR", {
                      maximumFractionDigits: 4,
                      minimumFractionDigits: 2,
                  });
        },
        upperFirstLetter(label) {
            return upperFirst(label.toLowerCase());
        },
        checkIsNumber(number) {
            if (isNull(number)) return false;
            return !isNaN(this.annotation.ceiling);
        },
    },
});
</script>

<style lang="sass" scoped>
.rates-wrapper
    margin: 16px 0

.rates-container
    display: flex
    width: 100%
    align-items: stretch

.rates-container-background
    background-color: #c6d6f5

.rates-container-inner
    padding: 24px
    width: 50%

.tags-badge
    display: inline-block
    border: 1px solid $color-secondary
    border-radius: 4px
    padding: 4px 16px
    margin: 1px 0

.tags-container
    border-top: 1px solid $color-grey
    width: 100%
    padding: 16px 24px

.rates-text
    margin-top: 24px
    border-top: 1px solid $color-grey
    padding-top: 24px

.rate-title
    margin-bottom: 16px
</style>
